import { useMatomo } from '@jonkoops/matomo-tracker-react';
import { toast } from 'react-toastify';
import HeroCarousel from '../../components/HeroCarousel';

function HeroSection() {
  const { trackEvent } = useMatomo();

  // TODO: Load this from a CMS
  const originLogos = ["DEMO/logos/madein.svg", "DEMO/logos/gdpr.svg", "DEMO/logos/iso.svg"];
  const videoComingSoon = () => {
    trackEvent({ category: 'hero section', action: 'video-available-soon' });
    toast.info('The video of our product will be available soon.', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "light",
    });}
    

  return (
    <div className="bg-blue-600 h-screen max-h-max max-lg:px-2 " style={{height: 'calc(100% - 800px)', backgroundImage: "url(gradient.svg)", backgroundSize: "cover"}}>
        <h1 className="text-6xl text-white font-bold pt-40 -mt-[90px] font-tt max-md:text-3xl">
          DiFi and Web3 portfolio monitoring.
        </h1>
        <HeroCarousel/>
        <p className="text-2xl text-slate-200 px-2 max-sm:w-10/12 max-sm:mx-auto">
        One single tool to tracked, analyzed and prepared crypto portfolio for accounting and tax reporting.
        <br/> Up to 70% less administrative effort.
       </p>
        <div className="flex flex-row flex-wrap justify-center mt-8">
          { originLogos.map((logo, i) => (
            <img src={logo} alt="logo" height="65px" className="m-6" key={"originLogo-" + i} />
          ))}
        </div>
        <div className="relative">
          <img src="Illustration.png" className="display-block m-auto w-6/12 mt-10 max-md:w-full max-md:px-10" alt="Product illustration" style={{maxWidth: "1024px"}}/>
          <img src="VideoButton.svg" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer hover:scale-105 active:scale-95 transition-transform" alt="Video button" onClick={videoComingSoon}/>
        </div>
    </div>
  );
}

export default HeroSection;